<template lang="">
    <div> 
        <b-row class="p-3">
            <b-col >
                <b-form-textarea
                    id="textarea-rows"
                    placeholder="ຄຳຖາມ......"
                    rows="8" v-model="frm.description"
                ></b-form-textarea>
                 
            </b-col>
        </b-row>
        <b-row class="p-3">
            <b-col>
                <b-button pill variant="outline-secondary" @click="onnewquestion" > <b-icon icon="question-circle-fill"></b-icon> ສົ່ງຄຳຖາມ</b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from "axios";
export default {
  created () {
    let date = new Date().toJSON();
    let login = localStorage.getItem("Login");
    this.user = JSON.parse(login);
    this.frm.create_by= this.user.username
    this.frm.create_date=date
    
  },
  data () {
    return {
        user:[],
        frm:{
            "description": "",
            "create_by": "",
            "create_date": "",
            "answers": []
        }
    }
  },
  methods: {
        goback() {
            this.$router.go(-1);
        },
        onnewquestion(){
            event.preventDefault();
            let rp_data = null;

            let postsdata = {
                table: "questions",
                rows: this.frm,
            };
            axios
                .post(
                    this.$store.getters.getBaseUrl + "/jsoninsert",
                    postsdata, {
                        headers: {
                            'Authorization': 'Bearer ' + this.user.login_hash
                        }
                    }
                )
                .then((rep) => {
                    rp_data = rep.data;
                    if (rp_data.msg == "Done") {
                        // alert(rp_data.desc);

                        this.$bvModal
                            .msgBoxOk(rp_data.desc, {
                                title: "ຂໍ້ວາມາແຈ້ງ.....",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            }).then(value => {
                                    if(value==true){
                                        this.$router.go(-1);
                                    }
                                })

                    } else {
                        //alert(rp_data.desc);
                        this.$bvModal
                            .msgBoxOk(rp_data.desc, {
                                title: "Confirmation",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                    }
                });
        }  
    },
    
}
</script>
<style lang="">
    
</style>